/**
 * Rule Build Constants
 */

// Layout dimensions
export const CHAT_SIDEBAR_WIDTH = 420;
export const TASKS_SIDEBAR_WIDTH = 280;

// Polling intervals (ms)
export const STATUS_POLL_INTERVAL = 2000;
export const MAX_POLL_DURATION = 5 * 60 * 1000; // 5 minutes

// Status colors
export const DRAFT_STATUS_COLORS = {
  draft: 'default',
  ready: 'success',
  saved: 'info',
} as const;

// Status labels
export const DRAFT_STATUS_LABELS = {
  draft: 'Draft',
  ready: 'Ready',
  saved: 'Saved',
} as const;

// Task status labels
export const TASK_STATUS_LABELS = {
  empty: 'Empty',
  generating: 'Generating...',
  ready: 'Ready',
  active: 'Active',
  saving: 'Saving...',
  completed: 'Completed',
  failed: 'Failed',
} as const;

// Source type labels
export const SOURCE_TYPE_LABELS = {
  document: 'From Document',
  prompt: 'From Prompt',
  existing: 'From Rule',
  manual: 'Manual',
} as const;

// Route paths
export const ROUTES = {
  LIST: '/rule-build',
  TASK: '/rule-build/:taskId',
} as const;
